// Angular
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

// Libraries
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { saveAs } from 'file-saver';

// Services

// Models
import { AppCleanup } from '../../../shared/models';
import { BlobHelper } from '../../helpers';

@Component({
	selector: 'image-display-dialog',
	templateUrl: './image-display-dialog.component.html',
	styleUrls: ['./image-display-dialog.component.scss'],
})
export class ImageDisplayDialogComponent extends AppCleanup implements OnInit, OnDestroy {
	componentTitle: string;
	fileName: string;
	base64Image: string;
	imageLink: string;
	downloadable: boolean = false;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: { title: string; base64Image: string; imageLink: string; downloadable: boolean },
		public domSanitizer: DomSanitizer
	) {
		super();
	}

	ngOnInit() {
		this.fileName = this.data?.title;
		this.componentTitle = this.fileName;
		this.imageLink = this.data?.imageLink;
		this.base64Image = this.data?.base64Image;

		if (this.data?.downloadable) {
			this.downloadable = true;
		}
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	downloadImage() {
		if (this.base64Image) {
			let blob = BlobHelper.dataUriToBlob(this.base64Image);
			saveAs(blob, this.fileName);
		} else if (this.imageLink) {
			var link = document.createElement('a');
			link.href = this.imageLink;
			link.download = this.fileName;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		}
	}
}
